import {Icon, Style } from 'ol/style.js';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';

import Notification from 'ol-ext/control/Notification';
import 'ol-ext/control/Notification.css';

//Color Picker
import '@simonwep/pickr/dist/themes/classic.min.css';
import Pickr from '@simonwep/pickr';


var menuTemplate = require("../../../../templates/linemenu.handlebars");

const themes = {
    theme: 'classic',
    appClass: 'beco-picker',
    defaultRepresentation: 'HEX',
    position: 'bottom-middle',

    components: {
        preview: true,
        opacity: false,
        hue: true,

        interaction: {
            hex: false,
            rgba: false,
            hsva: false,
            input: true,
            cancel: true,
            save: true
        }
    }
};

export default class LineMenu {

	constructor(){
		this.name = 'LineMenu';
		this.selectIntercation;
		this.notification = new Notification({});
        this.labelTextColor = '#FFFFFF';
        this.labelBorderColor = '#5D5755';
        this.labelTextSize = 12;

        var _this = this;

        $("#line-sidebar").append(menuTemplate);

        $( "#line-menu-close" ).bind( "click", function(event) {
            event.preventDefault();
            _this.close();
        });

        $( "#line-menu-save" ).bind( "click", function(event) {
            event.preventDefault();
            _this.save();
		});
		
		$('.beco-toggle-check .custom-control-input').change(function(){
            var toggle = $('.beco-toggle-check');

			if($(this).is(":checked")) {
				toggle.addClass("show");
			} else {
				toggle.removeClass("show");
			}
        });

        $('input.direction-label').change(function(){
           
            if ($(this).is(':checked')){
                $(this).prop('checked', true).attr('checked', 'checked');
            }
            else {
                $(this).prop('checked', false).removeAttr('checked');
            }
            
            $('input.direction-label').not(this).prop('checked', false).removeAttr('checked');
        });

        this.textColor = Pickr.create({
            el: '#textColor',
            default: this.labelTextColor,
            ...themes

        }).on('change', (color) => {
            // HEXA Color
            const hexaColor = color.toHEXA().toString();
            this.labelTextColor = hexaColor;
        }).on('save', () => {
            this.textColor.hide();
        });


        this.borderColor = Pickr.create({
            el: '#borderColor',
            default: this.labelBorderColor,
            ...themes

        }).on('change', (color) => {
            // HEXA Color
            const hexaColor = color.toHEXA().toString();
            this.labelBorderColor = hexaColor;

        }).on('save', () => {
            this.borderColor.hide();
        });

        this.range = document.getElementById("labelSize");
        this.bubble = document.getElementById("labelBubble");
        this.setBubble(this.range, this.bubble);
        this.range.addEventListener("input", () => {
            this.setBubble(this.range, this.bubble);
        });

	}

	showNotification(text){
        var div = $('<div>').text(text);
        this.notification.show(div.get(0));
    }

    setBubble(range, bubble) {
        this.labelTextSize = range.value;
        bubble.style.fontSize = `${this.labelTextSize}px`;      
    }

	open(feature,selectInteraction){
		this.feature = feature;
		

		if(feature){
			this.selectIntercation = selectInteraction;
			this.updateAandB(feature,selectInteraction);
			$(".beco-sidebar-line").addClass('show');
        	$(".beco-sidebar-line.show").parent().addClass('sidebar-active');
        	if(feature.getProperties() && feature.getProperties().disable){
                $("#disable").prop('checked', feature.getProperties().disable);
            }else{
                $("#disable").prop('checked', false);
            }

            if(feature.getProperties() && feature.getProperties().direction > 0){
                $("#oneway").prop('checked', true);
                $('.beco-toggle-check').addClass("show");
                if(feature.getProperties().direction == 1){
                	$("#atob").prop('checked', true);
                	$("#btoa").prop('checked', false);
                } else {
                	$("#btoa").prop('checked', true);
                	$("#atob").prop('checked', false);
                }

            }else{
                $("#oneway").prop('checked', false);
                $("#atob").prop('checked', true);
                $('.beco-toggle-check').removeClass("show");
            }

            if(feature.getProperties() && feature.getProperties().label ) {
                $("#InputLabel").val(feature.getProperties().label);
            }else {
                $("#InputLabel").val("");
            }

            if(feature.getProperties() && feature.getProperties().labelTextColor ) {
                this.textColor.setColor(feature.getProperties().labelTextColor);
            }

            if(feature.getProperties() && feature.getProperties().labelBorderColor ) {
                this.borderColor.setColor(feature.getProperties().labelBorderColor);
            }

            if(feature.getProperties() && feature.getProperties().labelTextSize ) {
                this.range.value = feature.getProperties().labelTextSize;
                
            }else {
                this.labelTextSize = 12;
                this.range.value = this.labelTextSize;
            }

            this.setBubble(this.range, this.bubble);
		}
        
    }

    updateAandB(feature,selectInteraction){

    	var featureStart = new Feature(
			                new Point(feature.getGeometry().getFirstCoordinate())
			      		);
    	featureStart.setStyle(this.style('a'));
		selectInteraction.getFeatures().push(featureStart);

		var featureEnd = new Feature(
			                new Point(feature.getGeometry().getLastCoordinate())
			      		);
		featureEnd.setStyle(this.style('b'));
		selectInteraction.getFeatures().push(featureEnd);
    }

    style(type) {

    	var icon = ( type == 'a' ? 'public/svg/a-icon.svg' : 'public/svg/b-icon.svg');
    	return new Style({
    		image: new Icon(({
				//color: '#df4a43',
				scale: 1,
				crossOrigin: null,
				src: icon,
				anchor :[0.5,0.5],
				anchorOrigin:'top-left'
            }))
        });
    }

    save(){

        var label = $("#InputLabel").val();
        var width = $("#InputWidth").val();

        if(label && label.length > 100) {
            $( ".validation.label-name" ).html("<p>Length cannot be more than 100<p>" );
            $( '.validation.label-name' ).parent().addClass('validation-beco');
            return;
        } else {
            $( ".validation.label-name p" ).remove();
            $( '.validation.beacon-name' ).parent().removeClass('validation-beco');
        }
        

    	var direction = 0;
    	if($("#oneway").is(":checked")){ 
    		var atob = $("#atob").is(":checked");
    		var btoa = $("#btoa").is(":checked");
    		if(atob) direction = 1;
    		if(btoa) direction = 2;
    	}

    	var props = {
            disable : $("#disable").is(":checked"),
            direction : direction,
            label : $("#InputLabel").val(),
            labelTextColor : this.labelTextColor,
            labelTextSize : this.labelTextSize,
            labelBorderColor : this.labelBorderColor,
        };

        this.feature.setProperties(props);
    	this.showNotification("Data saved successfully");
    	this.close();

        
    }

    close(){
        $(".beco-sidebar-line").removeClass('show');
        $(".beco-sidebar").parent().removeClass('sidebar-active'); 
        this.selectIntercation.getFeatures().clear();
        
    }
}